import { Button } from '@/components/ui/button';
import { CheckCircle } from '@phosphor-icons/react';

const SubmitButton = ({ loading, onSubmit }) => (
  <Button
    onClick={onSubmit}
    disabled={loading}
    size="lg"
    data-testid="submit-assessment-button"
    className="bg-gradient-to-r from-teal-600 to-emerald-600 text-white hover:from-teal-500 hover:to-emerald-500 shadow-md shadow-teal-600/20"
  >
    {loading ? 'Submitting...' : (
      <>
        Generate My Diagnostic Report
        <CheckCircle size={20} weight="fill" className="ml-2" />
      </>
    )}
  </Button>
);

export default SubmitButton;
